// extracted by mini-css-extract-plugin
module.exports = {"loadingWrp":"loading_loadingWrp__2XaQa","bigIcon":"loading_bigIcon__1W6eB","icon":"loading_icon__1T-cT"};